export default function FleetMetrics() {
  return <h1 className="text-2xl mb-4">Fleet metrics page</h1>;
}
